import OrderCostSummaryV2 from "../OrderCostSummaryV2";

const OrderCostSummaryV3 = OrderCostSummaryV2;

export default OrderCostSummaryV3;
